<app-alert-erro-customizado [alertErro]="erroImpressaoRecibo" [alertErroBotao]="'FECHAR'" [alertErroTitulo]="tituloMensagemErro" [alertErroMensagem]="mensagemErro" (alertErroFechou)="fecharAlertError($event)"></app-alert-erro-customizado>
<app-loading-generico [message]="loadingGenericoMessage" [loadingGenerico]="loadingGenerico"></app-loading-generico>

@if (alertImprimirRecibo) {
  <div class="body-alert">
    <div class="div-alert">
      <h1 class="titulo-alert">Imprimir recibo</h1>
      <p class="paragrafo mb-4">Gerar comprovante de pedido</p>
      @if (dadosPedido) {
        <div class="row">
          <div class="col-3">
            <span class="label-menor">PEDIDO</span>
            <p class="paragrafo">{{dadosPedido.idPedido}}</p>
          </div>
          <div class="col-3">
            <span class="label-menor">EMISSÃO</span>
            <p class="paragrafo">{{dadosPedido.dataEmissao | appDate: 'dd/MM/yyyy'}}</p>
          </div>
          <div class="col-3">
            <span class="label-menor">VALOR</span>
            <p class="paragrafo">R$: {{dadosPedido.valorTotal}}</p>
          </div>
        </div>
      }
      <div class="row mt-4">
        <div class="col-4">
          <span class="label-menor">LISTAR USUÁRIOS</span>
          <div class="input-group float-end align-items-center">
            <!-- QUANDO NÃO TIVER VALORES -->
            @if (valoresRetornados === null) {
              <input type="text" class="form-control" (keyup)="consultaCaracteres()" [(ngModel)]="valorDigitado" placeholder="Todos usuários" list="usuarios" id="caracteresUsuarios">
            }
            @if (valoresRetornados === null) {
              <button class="btn-icon" (click)="consultaCaracteres()">
                <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
              </button>
            }
            <!-- QUANDO TIVER VALORES -->
            @if (valoresRetornados) {
              <app-select
                [value]="usuarioSelecionado"
                (valueChanges)="usuarioSelecionado = $event"
                name="usuarioSelecionadoName"
                [options]="valoresRetornados"
                optionValue="idUsuario"
                optionText="nomeUsuario">
              </app-select>
            }
            <i
              class="fa fa-info-circle c-gray fa-1x icone-padrao"
              aria-hidden="true"
              [popover]="popoverListarUsuariosAlert"
              popoverTitle="Listar usuário"
              popoverPlacement="top"
              triggers="click"
              [outsideClick]="true">
            </i>
            <ng-template #popoverListarUsuariosAlert>
              <span class="texto-titulo text-nowrap">
                Você consegue listar por nome, <br>matrícula ou cpf.
              </span>
            </ng-template>
            <!-- LEGENDAS -->
            @if (valoresRetornados === null) {
              <p class="legenda mt-1 w-100">Digite pelo menos 4 caracteres</p>
            }
            @if (valoresRetornados) {
              <button class="buscar-outro-usuario mt-1 w-100 mb-1" (click)="limparValoresRetornados()">Buscar outro usuário</button>
            }
            @if (buscandoValores === false) {
              <p class="legenda-erro w-100 mb-2">Nenhum usuário foi encontrado</p>
            }
            <!-- FIM LEGENDAS -->
            <!-- LOADER BUSCA VALORES -->
            @if (buscandoValores === null) {
              <div>
                <div class="text-center">
                  <output class="spinner-border c-primary">
                    <span class="visually-hidden">Consultando usuários ...</span>
                  </output>
                </div>
                <p class="legenda-spinner">Consultando usuários ...</p>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          @if (departamentos) {
            <div class="mb-4">
              <label class="label-menor" for="descDepartamento">LISTAR DEPARTAMENTO</label>
              <app-select
                id="descDepartamento"
                [value]="departamentoSelecionado"
                (valueChanges)="departamentoSelecionado = $event"
                name="departamentoSelecionadoName"
                [options]="departamentos"
                optionValue="idDepartamento"
                optionText="descDepartamento"
                defaultDescription="Todos departamentos">
              </app-select>
            </div>
          }
          <!-- LOADING DEPARTAMENTOS -->
          @if (departamentos === null) {
            <div>
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando departamentos ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando departamentos ...</p>
            </div>
          }
          <!-- LOADING DEPARTAMENTOS -->
          @if (departamentos === false) {
            <div>
              <p class="legenda-erro">Erro ao consultar os departamentos, tente mais tarde.</p>
            </div>
          }
        </div>
        <div class="col-4">
          <div class="mb-4">
            <label class="label-menor" for="ordenacaoSelecionadoName">ORDEM LISTAGEM</label>
            <app-select
              [value]="ordenacaoSelecionado"
              (valueChanges)="ordenacaoSelecionado = $event"
              name="ordenacaoSelecionadoName"
              id="ordenacaoSelecionadoName"
                        [options]="[
                        {name : 'Nome do usuário' , value : ''} ,
                        {name : 'Código da matrícula' , value : 'matricula'} ,
                        {name : 'Departamento e nome usuários' , value : 'departamento'}

                        ]"
              optionValue="value"
              optionText="name">
            </app-select>
          </div>
        </div>
        <!-- PARTE DE ENDEREÇO -->
        <div class="col-12 mt-3 mb-4">
          @if (enderecosFaturamento) {
            <div class="mb-4">
              <label class="label-menor" for="enderecoSelecionadoName">LISTAR ENDEREÇO</label>
              <app-select
                [value]="enderecoSelecionado"
                (valueChanges)="enderecoSelecionado = $event"
                name="enderecoSelecionadoName"
                id="enderecoSelecionadoName"
                [options]="enderecosFaturamento"
                optionValue="idEndereco"
                optionText="descricaoLogradouro"
                defaultDescription="Todos endereços">
              </app-select>
            </div>
          }
          <!-- LOADING ENDEREÇO -->
          @if (enderecosFaturamento === null) {
            <div>
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando usuários ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando usuários ...</p>
            </div>
          }
          <!-- ERRO DE ENDEREÇO -->
          @if (enderecosFaturamento === false) {
            <div>
              <p class="legenda-erro">Erro ao consultar os endereços de faturamento, tente mais tarde.</p>
            </div>
          }
        </div>
      </div>
      <button class="botao me-3" (click)="imprimirRecibo()">LISTAR (imprimir)</button>
      <button class="botao-outline" (click)="fecharAlertImprimirRecibo()">FECHAR</button>
    </div>
  </div>
}
